export const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || "http://localhost:5000";

export const getApiUrl = (endpoint) => `${API_BASE_URL}${endpoint}`;

export const defaultHeaders = {
   "Content-Type": "application/json",
};
